function AboutSection(){
    return(<div className= "about">
        <h1>Bishal Rai</h1>
        <p>Software Developer</p>
        </div> 
    );
}

export default AboutSection;